import { render, staticRenderFns } from "./Repairform.vue?vue&type=template&id=6066e1d0&scoped=true&"
import script from "./Repairform.vue?vue&type=script&lang=js&"
export * from "./Repairform.vue?vue&type=script&lang=js&"
import style0 from "./Repairform.vue?vue&type=style&index=0&id=6066e1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066e1d0",
  null
  
)

export default component.exports